import { useCallback, useEffect, useState } from 'react';

const useIsMobile = (width: number) => {
	const windowIsDefined = typeof window === 'object';

	const isMobile = useCallback(
		() => (windowIsDefined ? window.innerWidth < width : false),
		[windowIsDefined, width]
	);

	const [activeClass, setActiveClass] = useState<boolean>(isMobile());

	useEffect(() => {
		if (!windowIsDefined) {
			return undefined;
		}

		const handleResize = () => {
			setActiveClass(isMobile());
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, [isMobile, windowIsDefined]);

	return activeClass;
};

export default useIsMobile;
